import { AndroidTVSettingsRepository } from "../../../../data/repository/androidTVSettings/AndroidTVSettingsRepository";
import { CurrentVersion, Message, Title, Url } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface AndroidTVSettingsUpdateCurrentLauncherAppVersionUseCase {
  invoke: (version: CurrentVersion) => Promise<ResponseState<Message>>;
}

export class AndroidTVSettingsUpdateCurrentLauncherAppVersionUseCaseImpl
  implements AndroidTVSettingsUpdateCurrentLauncherAppVersionUseCase
{
  private androidTVSettingsRepository: AndroidTVSettingsRepository;

  constructor(androidTVSettingsRepository: AndroidTVSettingsRepository) {
    this.androidTVSettingsRepository = androidTVSettingsRepository;
  }

  async invoke(version: CurrentVersion): Promise<ResponseState<Message>> {
    try {
      let response = await this.androidTVSettingsRepository.updateCurrentLauncherAppVersion(version);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
